<template>
  <div class="print-report-expenses">
    <vs-popup
      fullscreen
      title="Relatorio de despesas"
      @close="onClose"
      :active.sync="myPopUpRefPrint"
    >
      <div class="content-modal">
        <div v-show="loadingImport" style="width: 100%; text-align: center;">
          <img src="@/assets/loading-image.gif">
        </div>
        <div v-show="!loadingImport">
          <iframe
            id="frame"
            style="width: 100%; height: 85vh;"
            :src="linkPrint +'?no-cache='+Math.random()"
          ></iframe>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { EventBusExpenses } from "@/eventBus/eventBusExpenses";
export default {
  name: "PrintReportExpenses",
  props: ["linkPrint", "loadingImport", "event"],
  data() {
    return {
      myPopUpRefPrint: false
    };
  },
  mounted() {
    this.listeningEventBus();
  },
  methods: {
    listeningEventBus() {
      EventBusExpenses.$on(this.event, data => {
        this.myPopUpRefPrint = data;
      });
    },
    onClose() {
      this.$emit("closePopUpPrint", true);
      this.myPopUpRefPrint = false;
    }
  }
};
</script>

<style>
</style>
